declare var require: any;

export const site = {
    VERSION: require('../package.json').version
};
